module.exports = __webpack_public_path__ + "static/media/star.4e37aa62.svg";